import { useEffect, useState } from "react";
import "./SizeChartModal.css";

const SizeChartModal = ({ tableData, closeChartModal, onSizeSelect }) => {
    const [selectedRow, setSelectedRow] = useState(null);

    useEffect(() => {
        document.body.style.overflow = "hidden";

        return () => {
            document.body.style.overflow = "";
        };
    }, []);

    const handleApply = () => {
        if (selectedRow) {
            onSizeSelect(selectedRow);
            closeChartModal();
        }
    };

    return (
        <div className="size-chart-modal">
            <div className="close-chart" onClick={closeChartModal}>
                x
            </div>
            <div className="size-chart-container" onClick={(e) => e.stopPropagation()}>
                <h2>Size Chart</h2>

                <table className="size-chart-table">
                    <thead>
                        <tr>
                            {tableData[0].map((header, index) => (
                                <th key={index}>{header}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {tableData.slice(1).map((row, rowIndex) => (
                            <tr
                                key={rowIndex}
                                className={selectedRow === row[0] ? "selected-row" : ""}
                                onClick={() => setSelectedRow(row[0])}
                            >
                                {row.map((cell, cellIndex) => (
                                    <td key={cellIndex}>{cell}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>

                {/* <button disabled={selectedRow === null} className="apply-btn"  onClick={handleApply}>Применить</button> */}
            </div>
        </div>
    );
};


export default SizeChartModal;